import React from 'react';

import { Separator } from 'craft/components/SelectedToolbar/Separator';

import { MenuItems } from './MenuItems';

export const TEXT_STYLE_MENU_PORTAL_ID = 'selected-menu-text-style';
/**
 * NodeTextMenu is similar to SelectedTextMenu but works directly with
 * nodes without slate context.
 */
export const NodeTextMenu = () => {
  const elem = document.getElementById(TEXT_STYLE_MENU_PORTAL_ID);
  if (elem) {
    // Don't show node text menu, SelectedTextMenu will be active instead
    return null;
  }

  return (
    <>
      <Separator />
      <MenuItems />
    </>
  );
};
